//http://jsfiddle.net/jfhartsock/cM3ZU/
//https://stackoverflow.com/questions/4413590/javascript-get-array-of-dates-between-2-dates
Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf())
    dat.setDate(dat.getDate() + days);
    return dat;
}

export default {
    name: "Utils",
    getUsersWelcomeToXaddenPost() {
        var user = JSON.parse(localStorage.getItem("user"));
        return {
            id: 0,
            user_id: user.id,
            advert_id: 0,
            has_been_claimed: 0,
            is_claim_correct: 0,
            claim_value_scored: 0,
            date_claimed: "",
            date_claimed_timestamp: 757585,
            has_been_ignored: 0,
            has_expired: 0,
            date_ignored: "",
            date_ignored_timestamp: 7866,
            claim_value: 0,
            date_expired: "",
            date_expired_timestamp: 85859,
            date_to_expire: "",
            date_to_expire_timestamp: 76869,
            date_posted: "",
            date_posted_timestamp: 749933
        };
    },
    getUsersWelcomeToXaddenNotification() {
        var user = JSON.parse(localStorage.getItem("user"));
        return {
            id: 0,
            message_identity: "000000000",
            user_id: user.id,
            is_read: 1,
            title: "Welcome to xaddden",
            message: "Xadden is a social rewarding network",
            icon: "mdi-user",
            target_platform: "android_app",
            deep_link: "",
            date_posted: "",
            date_posted_timestamp: 749933,
            date_read: "",
            date_read_timestamp: 749933
        };
    },
    comma(val) {
        //https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        var t = parseFloat(val);
        var bt = t.toLocaleString();
        return bt;
    },
    remove_commas(str) {
        return str.replace(/,/g, '');
    },
    add_commas(num) {
        //https://stackoverflow.com/questions/6784894/add-commas-or-spaces-to-group-every-three-digits
        num = num.toString();
        var isNegative = num.startsWith("-");
        if (isNegative == true) {
            num = num.substr(1);
        }
        var str = num.split('.');
        if (str[0].length > 3) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1');
        }
        str = str.join('.');
        if (isNegative == true) {
            str = "-" + str;
        }
        return str;
    },
    pad0(val) {
        var temp = val.toString();
        if (temp.length < 2) {
            temp = "0" + temp;
        }
        return temp;
    },
    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    },
    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm.
     */
    shuffle_array(array) {
        for (let i = array.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1))
            let temp = array[i]
            array[i] = array[j]
            array[j] = temp
        }
        return array
    },
    get_num_days_between_two_dates(date_str1, date_str2) {
        var date1 = new Date(date_str1);
        var date2 = new Date(date_str2);

        // To calculate the time difference of two dates 
        var Difference_In_Time = date2.getTime() - date1.getTime();

        // To calculate the no. of days between two dates 
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        return Difference_In_Days;
    },
    get_dates_inbetween(start_date, end_date, formater) {
        if (typeof formater != 'function') {
            formater = (dt) => { return dt; };
        }
        //http://jsfiddle.net/jfhartsock/cM3ZU/
        //https://stackoverflow.com/questions/4413590/javascript-get-array-of-dates-between-2-dates


        function getDates(startDate, stopDate) {
            var dateArray = new Array();
            var currentDate = startDate;
            while (currentDate <= stopDate) {
                dateArray.push(currentDate)
                currentDate = currentDate.addDays(1);
            }
            return dateArray;
        }

        var res = [];
        var dateArray = getDates(start_date, end_date);
        for (var i = 0; i < dateArray.length; i++) {
            //console.log(dateArray[i].toString());
            var dt = dateArray[i];
            res.push(formater(dt));
        }
        return res;
    },
    validate: {
        is_required: (msg) => {
            if (typeof msg != 'string') {
                msg = "Value is required";
            }
            return (v) => {
                v = (v) ? v.toString().trim() : "";
                return !!v || msg;
            };
        },
        min_words: (num, msg) => {
            if (typeof num != 'number' || num <= 1) {
                num = 2;
            }
            if (typeof msg != 'string') {
                msg = "Value must be at least be " + num + " words long";
            }
            return (v) => {
                v = (v) ? v.trim().split(" ") : [];
                var temp = [];
                for (let index = 0; index < v.length; index++) {
                    const word = v[index].trim();
                    if (word.length > 0) {
                        temp.push(word);
                    }
                }
                return temp.length >= num || msg;
            };
        },
        min_max_length: (min, max, msg) => {
            if (typeof min != 'number' || min <= 1) {
                min = 2;
            }
            if (typeof max != 'number' || max > 1000 || max <= min) {
                max = 1000;
            }
            if (typeof msg != 'string') {
                msg = "Value length must be at between " + min + " and " + max + " letters long";
            }
            return (v) => {
                v = (v) ? v.trim() : "";
                return (v.length >= min && v.length <= max) || msg;
            };
        },
        max_length: (max, msg) => {
            if (typeof max != 'number' || max > 1000) {
                max = 1000;
            }
            if (typeof msg != 'string') {
                msg = "Value length must be at less than " + (max + 1) + " letters long";
            }
            return (v) => {
                v = (v) ? v.trim() : "";
                return (v.length <= max) || msg;
            };
        },
        email_format: (msg) => {
            /*https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript*/
            return (v) => {
                const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(v) || msg;
            }
        },
        if_provided_email_format: function (msg) {
            var is_required_va = this.is_required(msg);
            var email_va = this.email_format(msg);
            return (v) => {
                var is_provided = is_required_va(v);
                if (is_provided == true) {
                    //run the validation
                    var is_valid_email = email_va(v);
                    return (is_valid_email == true) || msg;
                }
                //return true
                return true;
            }
        },
        if_provided_phone_number: function (msg, is_officee = false) {
            var is_required_va = this.is_required(msg);
            var phone_va = this.phone_number(msg, is_officee);
            return (v) => {
                var is_provided = is_required_va(v);
                if (is_provided == true) {
                    //run the validation
                    var is_phone_valid = phone_va(v);
                    return (is_phone_valid == true) || msg;
                }
                //return true
                return true;
            }
        },
        phone_number: function (msg, is_officee = false) {
            var numeric_va = this.numeric(msg);
            return (v) => {
                if (!v) {
                    return msg;
                }
                v = v.toString().trim();
                //should only have digits
                var temp = v.replace("+", "").replaceAll(" ", "");
                var is_numeric = numeric_va(temp);
                if (is_numeric == false) {
                    return msg;
                }

                //77393543
                if (is_officee == false && (temp.length < 8 || v.length > 15)) {
                    return msg;
                }
                if (is_officee == true && v.length > 15) {
                    return msg;
                }

                //nyd
                //validate office numbers


                //https://www.npmjs.com/package/libphonenumber-js
                //nyd
                //add libphonenumber to validate phone numbers
                return (v != undefined) || msg;
            }
        },
        email_format_or_phone: function (msg, is_officee = false) {
            var email_va = this.email_format(msg);
            var phone_va = this.phone_number(msg, is_officee);
            return (v) => {
                if (!v) {
                    return msg;
                }
                var is_email_valid = email_va(v);
                var is_phone_valid = phone_va(v);
                //console.log("vals ", is_email_valid, is_phone_valid);
                if (is_email_valid == true && v.indexOf("@") < 0) {
                    is_email_valid = false;
                    is_phone_valid = false;
                }
                if (is_phone_valid == true && v.indexOf(" ") > -1) {
                    is_phone_valid = false;
                    is_email_valid = false;
                }
                if (is_phone_valid == true) {
                    var alphabets = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
                    var lc = v.toLowerCase();
                    for (var a = 0; a < alphabets.length; a++) {
                        var c = alphabets[a];
                        if (lc.indexOf(c) > -1) {
                            is_phone_valid = false;
                            is_email_valid = false;
                            break;
                        }
                    }

                }
                return (is_email_valid == true || is_phone_valid == true) || msg;
            }
        },

        /* eslint-disable no-useless-escape */
        equal_to: (v2, msg) => {
            return (v) => {
                return (!!v && v) === v2 || msg;
            }
        },
        length: (len, msg) => {
            return (v) => {
                var temp_len = (v) ? (v.length ? v.length : v.toString().length) : 0;
                return (v && (temp_len == len)) || msg;
            }
        },
        numeric: (msg) => {
            return (v) => {
                const re = /^\d+$/;
                return re.test(v) || msg;
            }
        },
        number_value: (msg) => {
            return (v) => {
                const re = /^[+-]?\d+(\.\d+)?$/;
                return re.test(v) || msg;
            }
        },
        if_provided_numeric: function (msg) {
            var is_required_va = this.is_required(msg);
            var numeric_va = this.numeric(msg);
            return (v) => {
                var is_provided = is_required_va(v);
                if (is_provided == true) {
                    //run the validation
                    var is_valid_number = numeric_va(v);
                    return (is_valid_number == true) || msg;
                }
                return true;
            }
        },
        min: (num, msg) => {
            return (v) => {
                v = parseFloat(v);
                //console.log("comp:", v, num, (v >= num));
                return (v >= num) || msg;
            }
        },
        min_max: (min, max, msg) => {
            if (typeof min != 'number') {
                min = 0;
            }
            if (typeof max != 'number') {
                max = 1000;
            }
            if (typeof msg != 'string') {
                msg = "Value length must be at between " + min + " and " + max;
            }
            return (v) => {
                const re = /^[+-]?\d+(\.\d+)?$/;
                if (re.test(v)) {
                    v = parseFloat(v);
                    return (v >= min && v <= max) || msg;
                } else {
                    return "Value must be a number";
                }
            };
        },
        if_provided_min_max: function (min, max, msg) {
            var is_required_va = this.is_required(msg);
            var min_max_va = this.min_max(min, max, msg);
            return (v) => {
                var is_provided = is_required_va(v);
                if (is_provided == true) {
                    //run the validation
                    var is_valid = min_max_va(v);
                    return (is_valid == true) || msg;
                }
                return true;
            }
        },
        dob_min_age: (num, msg) => {
            return (v) => {
                v = v.toString();
                var age = 0;
                var dt = new Date(v);
                var dob_year = dt.getFullYear();
                var this_year = (new Date()).getFullYear();
                age = this_year - dob_year;
                return (age >= num) || msg;
            }
        },
        is_date: (msg) => {
            return (v) => {
                var is_valid = true;
                v = (v) ? v.toString() : "";
                //var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
                var dateformat = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;
                // Match the date format through regular expression
                if (v.match(dateformat)) {
                    //Test which seperator is used '/' or '-'
                    var opera1 = v.split('/');
                    var opera2 = v.split('-');
                    var lopera1 = opera1.length;
                    var lopera2 = opera2.length;
                    // Extract the string into month, date and year
                    var pdate = null;
                    if (lopera1 > 1) {
                        pdate = v.split('/');
                    }
                    else if (lopera2 > 1) {
                        pdate = v.split('-');
                    }
                    var yy = parseInt(pdate[0]);
                    var mm = parseInt(pdate[1]);
                    var dd = parseInt(pdate[2]);
                    // Create list of days of a month [assume there is no leap year by default]
                    var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                    if (mm == 1 || mm > 2) {
                        if (dd > ListofDays[mm - 1]) {
                            is_valid = false;
                        }
                    }
                    if (mm == 2 && is_valid) {
                        var lyear = false;
                        if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
                            lyear = true;
                        }
                        if ((lyear == false) && (dd >= 29)) {
                            is_valid = false;
                        }
                        if ((lyear == true) && (dd > 29)) {
                            is_valid = false;
                        }
                    }
                }
                else {
                    is_valid = false;
                }
                return (is_valid) || msg;
            }
        }
    },
    can_access(user, menu_item) {
        //if user is super admin, they can access anything
        var can_access = false;
        if (user) {
            for (let index = 0; index < user.user_roles.length; index++) {
                const user_role = user.user_roles[index];
                var role_name = user_role.role.name;
                if (menu_item.roles.indexOf(role_name) >= 0) {
                    can_access = true;
                    break;
                }
            }
        }
        if (can_access == true) {
            return true;
        }

        var is_public = menu_item.roles.indexOf("public") >= 0;
        if (is_public) {
            return true;
        }
        return false;
    },
    is_admin(user) {
        if (user) {
            for (let index = 0; index < user.user_roles.length; index++) {
                const user_role = user.user_roles[index];
                var role_name = user_role.role.name;
                if (role_name == "backofficcee" || role_name == "super role") {
                    return true;
                }
            }
        }
        return false
    },
    get_default_page_attr() {
        return {
            title: "",
            crumps: [
            ],
            navbar_cols: 4,
            right_quick_links: []
        };
    },
    get_default_master_page_attr() {
        return {
            title: "",
            crumps: [
            ],
            navbar_cols: 4,
            quick_links: []
        };
    },
    default_icon: "mdi-file-cabinet",
    default_thumbnail:
        "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1604313402/botswana%20services/categories/categories_taygdc.jpg",
    get_default_category() {
        return {
            id: 0,
            name: "",
            icon: this.default_icon,
            thumb_nail: this.default_thumbnail,
            description: "",
            is_top_category: 0,
            top_category_level: 0,
        };
    },
    default_holidays_thumbnail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    default_business_logo: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    default_business_banner: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601730151/botswana%20services/website%20assets/Botswana-Stock-Exchange-COVID-19-Africa-Watch-1030x391_popbyj.png", //country botswana
    default_promotion_poster: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    default_promotion_thumbnail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    default_slide_thumbnail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    sub_categories_limit: 3,
    date_str_to_words(date, add_year, concat_word) {
        if (!add_year) {
            add_year = false;
        }
        if (!concat_word) {
            concat_word = "";
        }
        var word = "";
        var month_words = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (date) {
            var [year, month, day] = date.split('-');
            month = parseInt(month);
            day = parseInt(day);
            if (month) {
                word = month_words[month];
            }
            if (day == 1 || day == 21 || day == 31) {
                word = day + "ST " + concat_word + " " + word;
            } else if (day == 2 || day == 22 || day == 32) {
                word = day + "ND " + concat_word + " " + word;
            } else if (day == 3 || day == 23 || day == 33) {
                word = day + "RD " + concat_word + " " + word;
            } else {
                word = day + "TH " + concat_word + " " + word;
            }
        }
        if (add_year && add_year === true) {
            word = word + " " + year;
        }

        return word;
    },
    date_str_to_php_time(dt) {
        if (!dt) {
            var dt = new Date();
        } else {
            var dt = new Date(dt);
        }
        var time = dt.getTime();
        var dtTime = (time == 0) ? time : (time / 1000);
        return dtTime;
    },
    php_time_to_js_date_str(t, withTime = false) {
        var dtTime = t * 1000;
        var startDate = new Date();
        startDate.setTime(dtTime);
        var str = this.get_today_date_str(startDate, withTime);
        return str;
    },
    get_today_date_str: function (dt, withTime) {
        var today = dt;
        if (typeof today == "undefined" || today == null) {
            today = new Date();
        }
        if (typeof withTime == "undefined" || withTime == null) {
            withTime = false;
        }
        var m = (1 + today.getMonth());
        m = m < 10 ? ("0" + m) : m;
        var d = today.getDate();
        d = d < 10 ? ("0" + d) : d;
        var todatStr = today.getFullYear() + "-" + m + "-" + d;
        if (withTime == true) {
            todatStr = todatStr + " " + today.toLocaleTimeString();
        }
        return todatStr;
    },
    get_default_business: function () {
        var temp = {
            user_id: 0,
            name: "",
            tag_line: "",
            description: "",
            logo: this.default_business_logo,
            banner: this.default_business_banner,
            is_added_by_admin: 0,
            added_by_id: 0,
            is_assigned_to_owner: 0,
            former_owner_id: 0,
            assigned_by_id: 0,
            joined_on: "1970-01-01",
            joined_on_timestamp: 0,
            assigned_on: "1970-01-01",
            assigned_on_timestamp: 0,
            is_main_branch: 0,
            is_branch_of_id: -1,
            office_phone_number1: "",
            office_phone_number2: "",
            mobile_phone_number1: "",
            mobile_phone_number2: "",
            email_address_1: "",
            email_address_2: "",
            email_address_3: "",
            website_1: "",
            website_2: "",
            website_3: "",
            fax_number: "",
            pobox_number: "",
            facebook_link: "",
            twitter_link: "",
            instagram_link: "",
            youtube_link: "",
            linked_link: "",
            whatsapp_link: "",
            is_approved: 0,
            is_verified: 0,
            verified_on: "1970-01-01",
            verified_on_timestamp: 0,
            verified_by_id: 0,
            manual_directions: "",
            physical_address: "",
            lat: 0,
            lng: 0,
            time_zone: 0,
            country_id: 1, //botswana
            district_id: 1,
            city_id: 1,
            ward_id: 1,
            street_id: 1,
            tags: "",
            qr_code: "",
            views_count: 0,
            reviews_count: 0,
            searches_count: 0,
            rating: 0,
            is_local_company: 1,
            is_local_company_specified: 0,
            monday_openning_time_display: "08:00 am",
            monday_openning_time_value: 8.0,
            monday_closing_time_value: 24.59,
            monday_closing_time_display: "24:59",
            tuesday_openning_time_display: "08:00 am",
            tuesday_openning_time_value: 8.0,
            tuesday_closing_time_value: 24.59,
            tuesday_closing_time_display: "24:59",
            wednesday_openning_time_display: "08:00 am",
            wednesday_openning_time_value: 8.0,
            wednesday_closing_time_value: 24.59,
            wednesday_closing_time_display: "24:59",
            thursday_openning_time_display: "08:00 am",
            thursday_openning_time_value: 8.0,
            thursday_closing_time_value: 24.59,
            thursday_closing_time_display: "24:59",
            friday_openning_time_display: "08:00 am",
            friday_openning_time_value: 8.0,
            friday_closing_time_value: 24.59,
            friday_closing_time_display: "24:59",
            saturday_openning_time_display: "08:00 am",
            saturday_openning_time_value: 8.0,
            saturday_closing_time_value: 24.59,
            saturday_closing_time_display: "24:59",
            sunday_openning_time_display: "08:00 am",
            sunday_openning_time_value: 8.0,
            sunday_closing_time_value: 24.59,
            sunday_closing_time_display: "24:59",
            hollidays_openning_time_display: "08:00 am",
            hollidays_openning_time_value: 8.0,
            hollidays_closing_time_value: 24.59,
            hollidays_closing_time_display: "24:59",
            doc_idcopy_url: "",
            doc_cert_incoporation_url: "",
            doc_extr_comp_document_url: "",
            doc_cert_tax_url: "",
            doc_trade_liscence_url: "",
            doc_registration_cert_url: "",
            belongings: [],
            business_holliday_schedules: [],
            pictures: [],
            reviews: [],
            ratings: [],
            products: [],
            services: [],
            app_holidays: [],
            business_messages: [],
            district: { id: 1, name: "" },
            city_id: { id: 1, name: "" },
            ward_id: { id: 1, name: "" },
            street_id: { id: 1, name: "" },
            user: {
                id: 0,
                name: "",
                first_name: "",
                last_name: ""
            }
        };
        return temp;
    },
    get_default_promotion: function () {
        var temp = {
            business_id: 0,
            user_id: 0,
            title: "",
            description: "",
            media_url: "",
            banner_url: "",
            thumbnail_url: "",
            posted_on: "1990-01-01",
            posted_on_timestamp: 0,
            starts_on: "1990-01-01",
            starts_on_timestamp: 0,
            ends_on: "1990-01-01",
            ends_on_timestamp: 0,
            auto_end: 0,
            has_been_ended: 0,
            has_ended_automatically: 0,
            ended_on: "1990-01-01",
            ended_on_timestamp: 0,
            views_count: 0,
            business: this.get_default_business(),
            featured_promotions: []
        };
        return temp;
    },
    google_maps_api_key: "AIzaSyDNY7lI3UxRdxtsrfD55MUN9q-zhdcyWkE",
    yield_scanner(yield_list, target, attr, missing, description, is_array = false) {
        var display_name = "";
        if (target.name && target.name != undefined && target.name != null) {
            display_name = "#" + target.id + "-" + target.name;
        } else {
            display_name = "#" + target.id;
        }

        var default_values = [
            this.default_business_logo,
            this.default_business_banner,
            "0",
            "0:0",
            "00:00",
            "00:00 AM",
            "11:59 PM",
            "12:00 PM",
            "12:00 AM",
        ];


        if (target[attr] && target[attr] != undefined && target[attr] != null) {
            if (is_array == true) {
                if (target[attr].length == 0) {
                    yield_list.push({
                        business_id: target.id,
                        name: display_name,
                        missing: missing,
                        description: description
                    });
                }
            } else {
                var trimed_value = target[attr].toString().trim();
                if (trimed_value.length == 0 || default_values.indexOf(trimed_value) > -1) {
                    yield_list.push({
                        business_id: target.id,
                        name: display_name,
                        missing: missing,
                        description: description
                    });
                }
            }
        } else {
            yield_list.push({
                business_id: target.id,
                name: display_name,
                missing: missing,
                description: description
            });
        }
        return yield_list;
    },
    scan_businesses_missing_info: function (businesses, hollidays) {
        //lets do some processing
        //name, missing, description, business_id
        var list = [];
        for (var index = 0; index < businesses.length; index++) {
            var business = businesses[index];
            list = this.yield_scanner(list, business, "name", "Business Name", "The registered name or (trading as name) of your business");
            list = this.yield_scanner(list, business, "tag_line", "Tag Line", "Your one line sales statement  E.g Our customers happiness is our priority ");
            list = this.yield_scanner(list, business, "description", "Description", "You can describe what your business is doing, trading in or services given");
            list = this.yield_scanner(list, business, "logo", "Logo", "Please provide a logo that uniquely identifies your business, remove the default logo that we provide for you");
            list = this.yield_scanner(list, business, "banner", "Banner", "Please upload your own business banner, to customise your business page");
            list = this.yield_scanner(list, business, "office_phone_number1", "Officee Phone Number", "The phone number usually at officee that customers can use to call you");
            list = this.yield_scanner(list, business, "mobile_phone_number1", "Mobile Phone Number", "The mobile phone number that you move with that customers can use to call you");
            list = this.yield_scanner(list, business, "fax_number", "Fax Number", "Your fax number");
            list = this.yield_scanner(list, business, "pobox_number", "P.O.Box Number", "Your box officcee number, to receive physical mail posting from clients");
            list = this.yield_scanner(list, business, "manual_directions", "Manual Location Directions", "Provide a description for directions of how clients can get to your business");
            list = this.yield_scanner(list, business, "physical_address", "Physical Address or Plot Number", "Please enter your plot number");
            list = this.yield_scanner(list, business, "physical_address", "Physical Address or Plot Number", "Please enter your plot number");
            list = this.yield_scanner(list, business, "district_id", "District", "In which distrcit is the business located");
            list = this.yield_scanner(list, business, "ward_id", "Ward", "In which ward is the business located");
            list = this.yield_scanner(list, business, "street_id", "Street", "In which street is the business located");
            list = this.yield_scanner(list, business, "tags", "Search Hash Tags", "Please provide some hash tags e.g low prices, save big. To help your business appear more in search results");
            list = this.yield_scanner(list, business, "monday_openning_time_display", "Monday Opennig Time", "What time does your business open on mondays ?");
            list = this.yield_scanner(list, business, "monday_closing_time_display", "Monday Closing Time", "What time does your business close on mondays ?");
            list = this.yield_scanner(list, business, "tuesday_openning_time_display", "Tuesday Opennig Time", "What time does your business open on tuesdays ?");
            list = this.yield_scanner(list, business, "tuesday_closing_time_display", "Tuesday Closing Time", "What time does your business close on tuesdays ?");
            list = this.yield_scanner(list, business, "wednesday_openning_time_display", "Wednesday Opennig Time", "What time does your business open on wednesdays ?");
            list = this.yield_scanner(list, business, "wednesday_closing_time_display", "Wednesday Closing Time", "What time does your business close on wednesdays ?");
            list = this.yield_scanner(list, business, "thursday_openning_time_display", "Thursdays Opennig Time", "What time does your business open on thurdays ?");
            list = this.yield_scanner(list, business, "thursday_closing_time_display", "Thursdays Closing Time", "What time does your business close on thurdays ?");
            list = this.yield_scanner(list, business, "friday_openning_time_display", "Fridays Opennig Time", "What time does your business open on fridays ?");
            list = this.yield_scanner(list, business, "friday_closing_time_display", "Fridays Closing Time", "What time does your business close on fridays ?");
            list = this.yield_scanner(list, business, "saturday_openning_time_display", "Saturday Opennig Time", "What time does your business open on saturdays ?");
            list = this.yield_scanner(list, business, "saturday_closing_time_display", "Saturday Closing Time", "What time does your business close on saturdays ?");
            list = this.yield_scanner(list, business, "sunday_openning_time_display", "Sunday Openning Time", "What time does your business open on sundays ?");
            list = this.yield_scanner(list, business, "sunday_closing_time_display", "Sunday Closing Time", "What time does your business close on sundays ?");
            list = this.yield_scanner(list, business, "doc_idcopy_url", "Verification ID Copy", "Please upload your national id or passport to verify your business");
            list = this.yield_scanner(list, business, "doc_cert_incoporation_url", "Certificate Of Incoporation", "Please scann this document and upload it, its required to verify your business");
            list = this.yield_scanner(list, business, "doc_extr_comp_document_url", "Company Extract", "Please scann this document and upload it, its required to verify your business");
            list = this.yield_scanner(list, business, "doc_cert_tax_url", "Tax Certificate", "Please scann this document and upload it, its required to verify your business");
            list = this.yield_scanner(list, business, "doc_trade_liscence_url", "Trading Liscence", "Please scann this document and upload it, its required to verify your business");
            list = this.yield_scanner(list, business, "doc_registration_cert_url", "Certificate Of Registration", "Please scann this document and upload it, its required to verify your business");
            list = this.yield_scanner(list, business, "belongings", "Business Categories", "Please select at least one sub category for your business", true);
            list = this.yield_scanner(list, business, "pictures", "Photo Gallery", "Your business does not have any photoes in the gallery, please upload some snaps", true);
            list = this.yield_scanner(list, business, "products", "Products", "What products are you providing on the market, mention atleast one", true);
            list = this.yield_scanner(list, business, "services", "Services", "What services are you providing on the market, mention atleast one service", true);


            //the business may not be located in any city
            //list = this.yield_scanner(list, business, "city_id","City", "In which city is the business located"); 

            // list = this.yield_scanner(list, business, "email_address_1","Email Address", "The email address that clients can use to send you emails e.g mycoolbiz@gmail.com");
            // list = this.yield_scanner(list, business, "website_1","Website URL", "Your website url, the link e.g https://www.mycoolbiz.com");
            // list = this.yield_scanner(list, business, "whatsapp_link","Whatsapp Number", "Your personal or business whatsapp number");
            // list = this.yield_scanner(list, business, "facebook_link","Facebook Link", "The url to your facebook page");
            // list = this.yield_scanner(list, business, "twitter_link","Twitter Link", "The url to your twitter page");
            // list = this.yield_scanner(list, business, "instagram_link","Instagram Link", "The url to your instagram page");
            // list = this.yield_scanner(list, business, "youtube_link","Youtube Link", "The url to your youtube page");
            // list = this.yield_scanner(list, business, "linked_link","LinkedIn Account Link", "The url to your linkedIn page");
            // list = this.yield_scanner(list, business, "lat","Latitude", "Use the map form to add a latitude on the map, for where your business is located");
            // list = this.yield_scanner(list, business, "lng","Longitude", "Use the map form to add a longitude on the map, for where your business is located");
            for (var index2 = 0; index2 < hollidays.length; index2++) {
                var holiday = hollidays[index2];
                var schedules = business.business_holliday_schedules;
                if (schedules.length == 0) {
                    list = this.yield_scanner(list, {
                        id: business.id,
                        name: business.name,
                        nothings: []
                    }, "nothings", "Hoilday: " + holiday.name, "Whats your business schedule on this holiday ?", true);
                } else {
                    //look for it
                    var found_it = false;
                    for (var index3 = 0; index3 < schedules.length; index3++) {
                        var b_schedule = schedules[index3];
                        if (parseInt(b_schedule.holliday_id) == parseInt(holiday.id)) {
                            found_it = true;
                            break;
                        }
                    }
                    if (found_it == false) {
                        list = this.yield_scanner(list, {
                            id: business.id,
                            name: business.name,
                            nothings: []
                        }, "nothings", "Hoilday: " + holiday.name, "Whats your business schedule on this holiday ?", true);
                    }
                }
            }
        }
        return list;
    },
    process_promo_graph_data(promo_start_date_str, promo_end_date_str, promo_views, show_month = true, date_prop = 'view_on') {
        // var promo_start_date = new Date(promo_start_date_str);
        // var first_date = new Date(promo_start_date_str);
        // if(promo_views.length > 0){
        //     //the promo_views are ordered by ascending 
        //     var temp_dt_str = promo_views[0].view_on;
        //     var first_view_date = new Date(temp_dt_str);
        //     //compare first view and start date
        //     if(first_view_date.getTime() < promo_start_date.getTime()){
        //         //begin with this view
        //         first_date = first_view_date;
        //     }
        // }
        // var promo_end_date = new Date(promo_end_date_str);
        // var last_date = new Date(promo_end_date_str);
        // if(promo_views.length > 0){
        //     var temp_dt_str = promo_views[promo_views.length - 1].view_on;
        //     var last_view_date = new Date(temp_dt_str);
        //     //compare last view and end date
        //     if(last_view_date.getTime() > promo_end_date.getTime()){
        //         //end with this view
        //         last_date = last_view_date;
        //     }
        // }

        var first_date_temp = new Date(promo_start_date_str);
        var first_date = new Date(promo_start_date_str);
        var last_date_temp = new Date(promo_end_date_str);
        var last_date = new Date(promo_end_date_str);
        var num = this.get_num_days_between_two_dates(promo_start_date_str, promo_end_date_str);
        //console.log("Days are ", num);
        if (num < 30) {
            //buffer
            var diff = Math.ceil(30 - num);
            var half = Math.ceil(diff / 2);
            first_date = first_date_temp.addDays((-1 * half));
            last_date = last_date_temp.addDays(half);
        }
        var dates_range = this.get_dates_inbetween(first_date, last_date);


        //index view by date string
        var indexed_view = {};
        for (var p_index = 0; p_index < promo_views.length; p_index++) {
            var view = promo_views[p_index];
            var view_on_str = view[date_prop];
            var view_on_date = new Date(view_on_str);
            var index_date_str = this.get_today_date_str(view_on_date);
            if (indexed_view[index_date_str]) {
                indexed_view[index_date_str].push(view);
            } else {
                indexed_view[index_date_str] = [view];
            }
        }


        //group views by date
        var res = {};
        var values = [];
        var labels = [];
        for (var index = 0; index < dates_range.length; index++) {
            var plot_date = dates_range[index];
            var plot_date_str = this.get_today_date_str(plot_date);
            var year = plot_date.getFullYear().toString();
            var month = plot_date.getMonth() + 1;
            var day = plot_date.getDate();
            var plot_label = day + "/" + month; // + "/" + year[2] + year[3];
            if (show_month == false) {
                plot_label = day;
            }
            if (res[plot_date_str]) {
                //do nothing here
            } else {
                res[plot_date_str] = [];
            }
            //check in indexed view
            var value_to_push = 0;
            if (indexed_view[plot_date_str]) {
                res[plot_date_str] = indexed_view[plot_date_str];
                var count = indexed_view[plot_date_str].length;
                value_to_push = count;
            }
            values.push(value_to_push);
            var modulus = index % 3;
            if (modulus == 0) {
                //add a label
                if (value_to_push > 0) {
                    plot_label = plot_label + " (" + this.comma(value_to_push) + ")";
                }
                labels.push(plot_label);
            } else {
                plot_label = ".";
                if (value_to_push > 0) {
                    plot_label = plot_label + " (" + this.comma(value_to_push) + ")";
                }
                labels.push(plot_label);
            }


        }

        return {
            labels: labels,
            values: values
        };
    },
    get_default_fetaured_promotion: function () {
        var temp = {
            id: 0,
            promotion_id: 0,
            business_id: 0,
            user_id: 0,
            platform: "",
            page: "",
            section: "",
            promotion: this.get_default_promotion(),
            user: {
                id: 0,
                name: "",
                first_name: "",
                last_name: ""
            }
        };
        return temp;
    },
    get_default_advert: function () {
        var temp = {
            id: 0,
            user_id: 0,
            views_count: 0,
            clicks_count: 0,
            title: "",
            media_url: "",
            navigation_url: "",
            media_type: "",
            page: "",
            section: "",
            date_expired: "1989-01-01",
            date_expired_timestamp: 1,
            date_to_expire: "",
            date_to_expire_timestamp: 1,
            date_posted: "",
            date_posted_timestamp: 1,
            width_pixels: 0,
            height_pixels: 0,
            user: {
                id: 0,
                name: "",
                first_name: "",
                last_name: ""
            },
            advert_clicks: []
        };
        return temp;
    },
    process_advert_clicks_graph_data(promo_start_date_str, promo_end_date_str, adver_clicks) {
        var first_date_temp = new Date(promo_start_date_str);
        var first_date = new Date(promo_start_date_str);
        var last_date_temp = new Date(promo_end_date_str);
        var last_date = new Date(promo_end_date_str);
        var num = this.get_num_days_between_two_dates(promo_start_date_str, promo_end_date_str);
        //console.log("Days are ", num);
        if (num < 30) {
            //buffer
            var diff = Math.ceil(30 - num);
            var half = Math.ceil(diff / 2);
            first_date = first_date_temp.addDays((-1 * half));
            last_date = last_date_temp.addDays(half);
        }
        var dates_range = this.get_dates_inbetween(first_date, last_date);

        //index clicks by date string
        var indexed_clicks = {};
        for (var p_index = 0; p_index < adver_clicks.length; p_index++) {
            var click = adver_clicks[p_index];
            var view_on_str = click.clicked_on;
            var view_on_date = new Date(view_on_str);
            var index_date_str = this.get_today_date_str(view_on_date);
            if (indexed_clicks[index_date_str]) {
                indexed_clicks[index_date_str].push(click);
            } else {
                indexed_clicks[index_date_str] = [click];
            }
        }
        //group views by date
        var res = {};
        var values = [];
        var labels = [];
        for (var index = 0; index < dates_range.length; index++) {
            var plot_date = dates_range[index];
            var plot_date_str = this.get_today_date_str(plot_date);
            var year = plot_date.getFullYear().toString();
            var month = plot_date.getMonth() + 1;
            var day = plot_date.getDate();
            var plot_label = day + "/" + month; // + "/" + year[2] + year[3];
            if (res[plot_date_str]) {
                //do nothing here
            } else {
                res[plot_date_str] = [];
            }
            //check in indexed clicks
            var value_to_push = 0;
            if (indexed_clicks[plot_date_str]) {
                res[plot_date_str] = indexed_clicks[plot_date_str];
                var count = indexed_clicks[plot_date_str].length;
                value_to_push = count;
            }
            values.push(value_to_push);
            var modulus = index % 3;
            if (modulus == 0) {
                //add a label
                if (value_to_push > 0) {
                    plot_label = plot_label + " (" + this.comma(value_to_push) + ")";
                }
                labels.push(plot_label);
            } else {
                plot_label = ".";
                if (value_to_push > 0) {
                    plot_label = plot_label + " (" + this.comma(value_to_push) + ")";
                }
                labels.push(plot_label);
            }
        }

        return {
            labels: labels,
            values: values
        };
    },
    get_default_system_user() {
        var temp = {
            id: 0,
            name: " ",
            first_name: " ",
            last_name: " ",
            email: " ",
            status: "" //deactivated
        };
        return temp;
    },
    get_default_page_category() {
        var temp = {
            ... this.get_default_category(),
            businesses_count: 0,
            sub_categories_count: 0,
        };
        return temp;
    },
    get_default_page_sub_category() {
        var temp = {
            id: 0,
            name: "",
            icon: this.default_icon,
            thumb_nail: this.default_thumbnail,
            description: "",
            category_id: 0,
            category: {
                ... this.get_default_category(),
            },
            businesses_count: 0
        };
        return temp;
    },
    get_open_status(business) {
        var is_open = false;
        var days = [
            "sunday",
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
        ];
        var this_device_day = new Date().getDay();
        var device_day = days[this_device_day];

        var op_value = business[device_day + "_openning_time_display"];
        var cl_value = business[device_day + "_closing_time_display"];

        if (op_value.length == 0) {
            op_value = "not set";
        }
        if (cl_value.length == 0) {
            cl_value = "not set";
        }

        if (
            op_value != "closed" &&
            cl_value != "closed" &&
            op_value != "not set" &&
            cl_value != "not set"
        ) {
            //then lets get the times schedule times
            var start_x = parseFloat(business[device_day + "_openning_time_value"]); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
            var closes_x = parseFloat(business[device_day + "_closing_time_value"]); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
            var device_date_x = new Date();
            var now_device_hours = device_date_x.getHours();
            var now_device_mins = device_date_x.getMinutes();
            var now_device_time = parseFloat(
                now_device_hours + "." + now_device_mins
            );
            if (now_device_time >= start_x && now_device_time <= closes_x) {
                is_open = true;
            }
        } else if (op_value == "not set" || cl_value != "not set") {
            is_open = -1;
        }

        return is_open;
    },
    get_holiday_open_status(business, holidays) {
        var DateTodayDevice = new Date();
        var TodayDeviceDate = DateTodayDevice.getDate();
        var TodayDeviceMonth = DateTodayDevice.getMonth();

        var is_open = false;
        var is_a_holiday_today = false;
        if (business && holidays && business.business_holliday_schedules) {
            //index the business holiday entries
            var indexed_business_holidays = {};
            for (
                var index = 0;
                index < business.business_holliday_schedules.length;
                index++
            ) {
                var schedule = business.business_holliday_schedules[index];
                indexed_business_holidays[parseInt(schedule.holliday_id)] = schedule;
            }

            //go through the application holidays config
            for (var index = 0; index < holidays.length; index++) {
                var holiday = holidays[index];

                //used to detect for today
                var DateForHoliday = new Date(holiday.starts_on);
                var DateForHolidayDate = DateForHoliday.getDate();
                var DateForHolidayMonth = DateForHoliday.getMonth();

                if (
                    TodayDeviceDate != DateForHolidayDate ||
                    TodayDeviceMonth != DateForHolidayMonth
                ) {
                    //continue its not a holiday today so no need to check further
                    continue;
                }

                is_a_holiday_today = true;

                //look for this holiday from the business object
                if (indexed_business_holidays[parseInt(holiday.id)]) {
                    var schedule = indexed_business_holidays[parseInt(holiday.id)];
                    var op_value = schedule.opens;
                    var cl_value = schedule.closes;
                    if (op_value.length == 0) {
                        op_value = "not set";
                    }
                    if (cl_value.length == 0) {
                        cl_value = "not set";
                    }
                    //for the business to be oppened on this holiday it must be today
                    //and having a schedule setup, thats why this logic is written here
                    if (schedule.opens_time != "closed") {
                        //then lets get the times schedule times
                        var start_x = parseFloat(schedule.opens_time); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
                        var closes_x = parseFloat(schedule.ends_time); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
                        var device_date_x = new Date();
                        var now_device_hours = device_date_x.getHours();
                        var now_device_mins = device_date_x.getMinutes();
                        var now_device_time = parseFloat(
                            now_device_hours + "." + now_device_mins
                        );
                        if (now_device_time >= start_x && now_device_time <= closes_x) {
                            is_open = true;
                        }
                    } else {
                        is_open = false;
                    }
                    break;
                } else {
                    //because the business is missing a holiiday entry
                    is_open = -1;
                }
            }
        } else {
            is_open = -1; //not set
        }

        return {
            is_open: is_open,
            is_a_holiday_today: is_a_holiday_today,
        };
    },
    set_is_business_open(business,holidays) {
        var holiday_schedules = this.get_holiday_open_status(business,holidays);
        var normal_schedule_open = this.get_open_status(business);
        var msg = "";
        var color = "";
        var is_open = false;
        var open_status = "";
        var is_holiday_open = holiday_schedules.is_open;
        var is_a_holiday_today = holiday_schedules.is_a_holiday_today;
        var is_week_open = normal_schedule_open;

        if (is_a_holiday_today && is_holiday_open === -1) {
            //note the === strict comparison used here
            msg =
                "This business may be open or close, because there is no schedule setup for this holiday";
            color = "orange";
            is_open = -1;
            open_status = "Open or Closed";
        } else if (is_a_holiday_today && is_holiday_open === false) {
            //note the === strict comparison used here
            msg = "This business is CLOSED, by this time on this holiday";
            color = "red";
            is_open = false;
            open_status = "Closed";
        } else if (is_a_holiday_today && is_holiday_open === true) {
            //note the === strict comparison used here
            msg = "This business is OPEN, by this time on this holiday";
            color = "green";
            is_open = true;
            open_status = "Open";
        } else if (is_week_open === true) {
            //note the === strict comparison used here
            msg = "This business is OPEN";
            color = "green";
            is_open = true;
            open_status = "Open";
        } else if (is_week_open === false) {
            //note the === strict comparison used here
            msg = "This business is CLOSED";
            color = "red";
            is_open = false;
            open_status = "Closed";
        } else if (is_week_open === -1) {
            msg =
                "This business may be open or close, because there is no schedule setup for today";
            color = "orange";
            is_open = -1;
            open_status = "Open or Closed";
        }
        return {
            msg: msg,
            color: color,
            is_open: is_open,
            open_status: open_status,
        };
    },
    get_default_slider() {
        return {
            id: 0,
            name:"",
            page:"home",
            click_url:"",
            position:1,
            comment:"",
            slide_picture: this.default_slide_thumbnail
        };
    },  
}